import { Link } from "react-router-dom";

const ViewAllHeader = ({ title, to }) => {
  return (
    <div className="flex items-center justify-between mb-4 border-b pb-2">
      <h2 className="text-xl font-bold text-red-600">
        {title}
      </h2>

      {to && (
        <Link
          to={to}
          className="text-sm font-semibold text-gray-600 hover:text-red-600 transition"
        >
          View All →
        </Link>
      )}
    </div>
  );
};

export default ViewAllHeader;
